import styled from 'styled-components';
import { alphabetColors } from '../../../shared/constants';

export const Container = styled.div<{ alphabet?: string }>`
  .highlight {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
    max-width: 700px;
    .profile-icon {
      background: ${({ alphabet }) =>
        alphabetColors[(alphabet || '').toLowerCase()] || '#ffe0b2'};
      border-radius: 79px;
      width: 70px;
      height: 70px;
      margin-right: 42px;
      font-weight: 500;
      font-size: 22px;
      line-height: 70px;
      color: white;
      text-align: center;
    }

    .fullName {
      font-weight: bold;
      font-size: 16px;
      line-height: 20px;
      color: var(--text-default);
      margin-bottom: 8px;
    }

    .email {
      font-size: 14px;
      line-height: 20px;
      color: var(--text-default);
    }
    a {
      font-size: 12px;
      line-height: 14px;
      text-decoration: underline;
      color: #7d7d7d;
    }
  }

  .moreinfo {
    display: grid;
    grid-template-columns: 200px 200px 200px;
    max-width: 700px;

    .item {
      margin-bottom: 34px;
      .title {
        font-size: 14px;
        color: var(--color-smoke-700);
        margin-bottom: 4px;
      }
      .value {
        font-weight: 600;
        font-size: 14px;
        color: var(--color-elephant-900);
        word-break: break-all;
      }
    }
  }

  .helpbanner {
    background: #ebeff3;
    border-radius: 4px;
    padding: 10px;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
    color: var(--color-elephant-700);
    max-width: 340px;
    margin-bottom: 8px;
    a {
      text-decoration: underline;
    }
  }

  button.reset-api-key {
    margin: 16px 0 0 0;
  }
`;

export const StyledSignature = styled.div`
  #quill-signature {
    display: flex;
    flex-direction: column-reverse;
  }

  .ql-toolbar.ql-snow {
    border-top: 0 !important;
    border-bottom-left-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
  }

  .ql-container.ql-snow {
    border-top: 1px solid #ccc !important;
    border-bottom: 0 !important;
    border-top-left-radius: 4px !important;
    border-top-right-radius: 4px !important;
    min-height: 100px;
  }
`;

export const ProfileContainer = styled.div`
  height: 100%;
  display: flex;
  padding: 14px;
  .profileForm {
    background: #fff;
  }
`;
